module.exports = __webpack_public_path__ + "img/location-away.4fdf9ffe.svg";